<div class="container">
  <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="1" />
</div>
